import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import { IconButton } from '@mui/material';
import Tooltip from '@mui/material/Tooltip';
import * as React from 'react';
import DialogFilterDescription from '../../DialogFilterDescription';

export default function NewRecentFilterDescription() {
    const [showInfo, setShowInfo] = React.useState<boolean>(false);

    const handleClick = () => {
        setShowInfo(!showInfo);
    };

    return (
        <>
            <Tooltip title="Filter Information" disableInteractive>
                <IconButton aria-label="Filter Information" onClick={handleClick} size="small">
                    <HelpOutlineIcon />
                </IconButton>
            </Tooltip>
            {showInfo && (
                <DialogFilterDescription isOpen={showInfo} onConfirmHandler={handleClick} />
            )}
        </>
    );
}
